import React from 'react';
import { Alert, Chip, Stack, Typography } from '@mui/material';

import type { CustomStep } from '@shared/patient-intake-status';

type MessageStepViewerProps = {
  step: CustomStep['MESSAGE'];
};

export const MessageStepViewer: React.FC<MessageStepViewerProps> = ({ step }) => {
  const { metadata } = step;

  const { messageContext } = metadata;

  if (!messageContext) {
    return <Alert severity="warning">Message context not found for step.</Alert>;
  }

  const isPending = step.currentStatus?.status === 'PENDING';

  return (
    <Stack gap={1}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
        <Typography variant="subtitle2" gutterBottom>
          Message Context
        </Typography>
        <Chip label={messageContext} size="small" variant="outlined" sx={{ textTransform: 'capitalize' }} />
      </Stack>

      {isPending && (
        <Alert severity="info">Please review the {messageContext} chat and take the required action.</Alert>
      )}
    </Stack>
  );
};
